import { apiRequest } from '@peruselab/api-client/httpRequest';
import type { Transcript, TranscriptCoordinateMapping } from './Transcript';

export async function getTranscript(id: string): Promise<Transcript> {
  return apiRequest<Transcript>(`/transcripts/${encodeURIComponent(id)}`, 'transcript');
}

export async function getTranscriptCoordinateMapping(
  id: string,
  locusOrdinal: number,
  genomicPosition: number
): Promise<TranscriptCoordinateMapping> {
  const query = new URLSearchParams({ locusOrdinal: String(locusOrdinal), genomicPosition: String(genomicPosition) });
  return apiRequest<TranscriptCoordinateMapping>(
    `/transcripts/${encodeURIComponent(id)}/coordinate-mapping?${query}`,
    'transcript coordinate'
  );
}
